export default "__VITE_ASSET__1b871223__"